(function () {
  var root = document.documentElement;
  var toggle = document.querySelector('.sply-mode-toggle');
  var KEY = 'sply-mode';
  var reduceMo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (toggle) {
    toggle.addEventListener('click', function () {
      var apply = function () {
        var next = root.classList.contains('sply--dark') ? 'light' : 'dark';
        root.classList.remove('sply--light', 'sply--dark');
        root.classList.add('sply--' + next);
        try { localStorage.setItem(KEY, next); } catch (e) {}
      };
      if (!reduceMo && document.startViewTransition) {
        root.classList.add('sply--mode-vt');
        var vt = document.startViewTransition(apply);
        vt.finished.then(function () { root.classList.remove('sply--mode-vt'); }, function () { root.classList.remove('sply--mode-vt'); });
      } else {
        apply();
      }
    });
  }
})();

/* remove ONLY the floating spam-protection badge (hCaptcha/reCAPTCHA); never an element that holds form fields */
(function(){
  function floating(e){ var p=getComputedStyle(e).position; return p==='fixed'||p==='absolute'; }
  function safeHide(e){ if(!e||!e.style) return; if(e.querySelector && e.querySelector('input,textarea,select,button[type="submit"]')) return; e.style.setProperty('display','none','important'); }
  function nuke(){
    document.querySelectorAll('.grecaptcha-badge,.h-captcha').forEach(safeHide);
    document.querySelectorAll('iframe[src*="hcaptcha"],iframe[title*="hcaptcha" i],iframe[src*="recaptcha"]').forEach(function(f){
      var w=f, hops=0;                              // climb to the floating wrapper that is the badge
      while(w && w!==document.body && hops<5){ if(floating(w)){ safeHide(w); return; } w=w.parentElement; hops++; }
    });
    document.querySelectorAll('body > *').forEach(function(e){
      if(floating(e) && e.querySelector && e.querySelector('iframe[src*="hcaptcha"],iframe[title*="hcaptcha" i]')) safeHide(e);
    });
  }
  nuke();
  try{ new MutationObserver(nuke).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
  window.addEventListener('load',nuke);
  [250,700,1500,3000,5000].forEach(function(t){ setTimeout(nuke,t); });
})();

/* FAQ accordion (delegated, works on any page) */
document.addEventListener('click', function (e) {
  var q = e.target.closest && e.target.closest('[data-sply-faq-q]');
  if (!q) return;
  q.setAttribute('aria-expanded', q.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
});

/* shared scroll reveal (gallery, lookbook, editorial, etc.) */
(function () {
  function reveal(items) { Array.prototype.forEach.call(items, function (it, i) { it.style.transitionDelay = (i * 60) + 'ms'; it.classList.add('is-in'); }); }
  var supported = ('IntersectionObserver' in window);
  var obs = supported ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (!en.isIntersecting) return; reveal(en.target.querySelectorAll('[data-reveal-item]')); obs.unobserve(en.target); });
  }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }) : null;
  function observe(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-reveal]'), function (g) {
      if (g._revObs) return; g._revObs = true;
      if (obs) obs.observe(g); else reveal(g.querySelectorAll('[data-reveal-item]'));
    });
  }
  observe(document);
  // theme editor: a re-rendered section isn't observed, so reveal its content immediately (no "vanish until save")
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var t = e.target; if (!t || !t.querySelectorAll) return;
      Array.prototype.forEach.call(t.querySelectorAll('[data-reveal-item], .sply-surface-grid .sply-card'), function (it) { it.classList.add('is-in'); });
    });
  }
})();

/* gallery lightbox */
(function () {
  var box = null, imgs = [], idx = 0;
  function build() {
    box = document.createElement('div');
    box.className = 'sply-lb';
    box.innerHTML = '<button class="sply-lb__close" data-lb-close aria-label="Close">\u00d7</button>'
      + '<button class="sply-lb__nav sply-lb__nav--prev" data-lb-prev aria-label="Previous">\u2039</button>'
      + '<figure class="sply-lb__fig"><img class="sply-lb__img" alt=""><figcaption class="sply-lb__cap"></figcaption></figure>'
      + '<button class="sply-lb__nav sply-lb__nav--next" data-lb-next aria-label="Next">\u203a</button>';
    document.body.appendChild(box);
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('[data-lb-close]')) close();
      else if (e.target.closest('[data-lb-prev]')) go(-1);
      else if (e.target.closest('[data-lb-next]')) go(1);
    });
  }
  function show() {
    var im = imgs[idx];
    box.querySelector('.sply-lb__img').src = im.getAttribute('data-full') || im.src;
    var cap = im.getAttribute('data-caption') || '', c = box.querySelector('.sply-lb__cap');
    c.textContent = cap; c.style.display = cap ? 'block' : 'none';
  }
  function go(d) { idx = (idx + d + imgs.length) % imgs.length; show(); }
  function open(g, i) { imgs = Array.prototype.slice.call(g.querySelectorAll('.sply-gallery__img')); if (!imgs.length) return; idx = i; if (!box) build(); show(); box.classList.add('is-open'); document.documentElement.classList.add('sply-lb-open'); }
  function close() { if (box) { box.classList.remove('is-open'); document.documentElement.classList.remove('sply-lb-open'); } }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sply-gallery-open]');
    if (!b) return;
    var g = b.closest('[data-sply-gallery]'); if (!g) return;
    open(g, parseInt(b.getAttribute('data-sply-gallery-open'), 10) || 0);
  });
  document.addEventListener('keydown', function (e) {
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') close(); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1);
  });
})();

/* slide-in nav menu (2-bar icon) */
(function () {
  var menu = document.querySelector('[data-sply-menu]');
  if (!menu) return;
  var closeT = null;
  function open() {
    if (closeT) { window.clearTimeout(closeT); closeT = null; }
    menu.classList.remove('is-closing');
    menu.hidden = false;
    document.documentElement.classList.add('sply-menu-open');
    window.dispatchEvent(new CustomEvent('sply:overlayopen', { detail: 'menu' }));
    glitchIn();
  }
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function glitchIn() {
    var items = menu.querySelectorAll('.sply-menu__link,.sply-menu__sublink');
    for (var i = 0; i < items.length; i++) (function (el, idx) {
      var fin = el.getAttribute('data-txt');
      if (fin == null) { fin = el.textContent; el.setAttribute('data-txt', fin); }
      if (el._iv) { window.clearInterval(el._iv); el._iv = null; }
      el.style.opacity = '0';
      window.setTimeout(function () {
        el.style.opacity = '1';
        if (RM) { el.style.opacity = ''; el.textContent = fin; return; }
        var glyphs = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789', q = [];
        for (var k = 0; k < fin.length; k++) { var c = fin.charAt(k), fx = (c === ' ' || c === '-' || c === '/' || c === '.'); q.push({ c: c, fx: fx, end: fx ? 0 : Math.round(k * 1.6) + 6 + Math.floor(Math.random() * 5) }); }
        var fr = 0;
        el._iv = window.setInterval(function () {
          var o = '', d = 0;
          for (var jx = 0; jx < q.length; jx++) { var t = q[jx]; if (t.fx || fr >= t.end) { o += t.c; d++; } else { o += glyphs.charAt(Math.floor(Math.random() * glyphs.length)); } }
          el.textContent = o; fr++;
          if (d === q.length) { window.clearInterval(el._iv); el._iv = null; el.textContent = fin; el.style.opacity = ''; }
        }, 38);
      }, idx * 115);
    })(items[i], i);
  }
  window.addEventListener('sply:overlayopen', function (e) { if (e.detail !== 'menu' && !menu.hidden) close(); });
  function close() {
    if (menu.hidden || menu.classList.contains('is-closing')) return;
    menu.classList.add('is-closing');
    document.documentElement.classList.remove('sply-menu-open');
    var items = menu.querySelectorAll('.sply-menu__link,.sply-menu__sublink');
    var n = items.length;
    for (var i = 0; i < n; i++) (function (el, rev) {
      if (el._iv) { window.clearInterval(el._iv); el._iv = null; el.textContent = el.getAttribute('data-txt') || el.textContent; }
      el.style.transition = 'opacity .3s ease';
      window.setTimeout(function () { el.style.opacity = '0'; }, rev * 85);   // last link fades first
    })(items[i], n - 1 - i);
    var dur = (n > 1 ? (n - 1) * 85 : 0) + 380;
    if (dur < 520) dur = 520;
    closeT = window.setTimeout(function () {
      menu.hidden = true;
      menu.classList.remove('is-closing');
      for (var k = 0; k < items.length; k++) { items[k].style.transition = ''; }
      closeT = null;
    }, dur);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sply-menu-open]')) { e.preventDefault(); if (menu.hidden) open(); else close(); return; }
    if (e.target.closest('[data-sply-menu-close]')) { e.preventDefault(); close(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) close(); });
})();

/* enter modal — homepage intro, hard-coded once per session */
(function () {
  function revealBg(m) {
    var bg = m.querySelector('.sply-enter__bg'); if (!bg || bg._bg) return; bg._bg = true;
    var img = bg.querySelector('img'); if (!img) return;   // video shows its first frame / poster immediately
    var show = function () { bg.classList.add('is-loaded'); };
    if (img.complete && img.naturalWidth) show();
    else { img.addEventListener('load', show, { once: true }); img.addEventListener('error', show, { once: true }); }
  }
  function open(m) { m.hidden = false; m.classList.remove('is-exit'); document.documentElement.classList.add('sply-enter-open'); revealBg(m); }
  function close(m) { m.hidden = true; document.documentElement.classList.remove('sply-enter-open'); }
  function dismiss(m, href) {
    if (m.classList.contains('is-exit')) return;
    m.classList.add('is-exit');
    window.setTimeout(function () { document.documentElement.classList.remove('sply-enter-open'); m.hidden = true; if (href) window.location.href = href; }, 760);
  }
  function bind(m) {
    if (!m || m._bound) return; m._bound = true;
    m.addEventListener('click', function (e) { var p = e.target.closest('[data-enter-go]'); if (p) { e.preventDefault(); dismiss(m, p.getAttribute('data-href') || null); } });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = document.querySelector('[data-sply-enter]');
    if (m && !m.hidden && document.documentElement.classList.contains('sply-enter-open')) dismiss(m, null);
  });

  var design = !!(window.Shopify && Shopify.designMode);
  if (design) {
    // editor: re-show on select AND on re-render (section:load), hide on deselect
    function has(t) { return t && t.querySelector && t.querySelector('[data-sply-enter]'); }
    function show() { var m = document.querySelector('[data-sply-enter]'); if (m) { bind(m); open(m); } }
    document.addEventListener('shopify:section:select', function (e) { if (has(e.target)) show(); });
    document.addEventListener('shopify:section:load', function (e) { if (has(e.target)) show(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (has(e.target)) { var m = document.querySelector('[data-sply-enter]'); if (m) close(m); } });
    return;
  }

  var modal = document.querySelector('[data-sply-enter]');
  if (!modal) return;
  bind(modal);
  var seen = false; try { seen = sessionStorage.getItem('sply-entered') === '1'; } catch (e) {}
  if (seen) { if (modal.parentNode) modal.parentNode.removeChild(modal); return; }
  try { sessionStorage.setItem('sply-entered', '1'); } catch (e) {}
  open(modal);
})();
